import axiosRequest from '@/utils/axios-default-request';


/** 
 * 消息阅读状态  未读 0 已读 1 
 */
/**
 * 获取未读消息数量 params 
 * @param Long supUserId 供应商用户id
 * @back msgJlCount消息通知未读数量 feedbackCount意见反馈已处理未读数量 xxCount 未读信息总数量
 * */ 
let getUnreadMsg = (data)=>axiosRequest.postBody('/clientinterface/getUnreadMsg',data)

/**
 * 消息通知一键已读
 * @param Long supUserId 供应商用户id
 * @back 返回操作成功与失败的结果
 * */ 
 let xxtzyjyd = (data)=>axiosRequest.postBody('/clientinterface/xxtzyjyd',data)

 /**
 * 消息通知列表
 * @param Long supUserId 供应商用户id
 * @back 返回消息通知记录实体类 
 * xxMsgNotificationJlId;消息记录id 
 * xxMsgNotificationId;消息通知
 * idreceiver;接收人
 * receiverName;接收人名称
 * readingStatus; 阅读状态
 * readingTime;阅读时间
 * title;消息通知标题
 * content;消息通知内容
 * */ 
  let getXXTZDatas = (data)=>axiosRequest.postBody('/clientinterface/getXXTZDatas',data)

/**
 * 更改消息通知阅读状态
 * @param Long xxMsgNotificationJlId 消息通知记录id
 * @back 返回操作成功与失败的结果
 * */ 
 let upXXTZReadingStatus = (data)=>axiosRequest.postBody('/clientinterface/upXXTZReadingStatus',data)




/** 意见反馈状态 反馈中 0  已处理1 */

/**
 * 意见反馈类型
 * @param Long xxMsgNotificationJlId 消息通知记录id
 * @back 意见反馈名称  意见反馈值  其他	5  问题疑惑 4   投诉与建议 3  体验优化 2  平台BUG 1
 * */ 
 let getFeedbackTypeData = (data)=>axiosRequest.postBody('/clientinterface/getFeedbackTypeData',data)

/**
 * 意见反馈列表
 * @param Long supUserId 供应商用户id
 * */ 
 let getFeedbackData = (data)=>axiosRequest.postBody('/clientinterface/getFeedbackData',data)

 /**
 * 添加意见反馈
 * */ 
  let addFeedBack = (data)=>axiosRequest.postBodyJson('/clientinterface/addFeedBack',data)

/**
 * 意见反馈详情
 * @param Long xxFeedbackId 意见反馈id
 * @back 意见反馈名称  意见反馈值  其他	5  问题疑惑 4   投诉与建议 3  体验优化 2  平台BUG 1
 * */ 
 let getFeedbackDetail = (data)=>axiosRequest.postBody('/clientinterface/getFeedbackDetail',data)

 /**
 * 更改意见反馈阅读状态
 * @param Long xxFeedbackId 意见反馈id
 * @back 意见反馈名称  意见反馈值  其他	5  问题疑惑 4   投诉与建议 3  体验优化 2  平台BUG 1
 * */ 
  let upYYFKReadingStatus = (data)=>axiosRequest.postBody('/clientinterface/upYYFKReadingStatus',data)



export default{
    /** 消息通知页面 */
    getUnreadMsg,//获取未读消息数量
    xxtzyjyd,//消息通知一键已读
    getXXTZDatas,//
    upXXTZReadingStatus,//更改消息通知阅读状态


    /** 意见反馈页面 */
    getFeedbackTypeData,//意见反馈类型
    getFeedbackData,//意见反馈列表
    addFeedBack,//添加意见反馈
    getFeedbackDetail,//意见反馈详情
    upYYFKReadingStatus,//更改意见反馈阅读状态
}